import { render, staticRenderFns } from "./ConfigHotelSobreEditar.vue?vue&type=template&id=6b4179aa&scoped=true&"
import script from "./ConfigHotelSobreEditar.vue?vue&type=script&lang=js&"
export * from "./ConfigHotelSobreEditar.vue?vue&type=script&lang=js&"
import style0 from "./ConfigHotelSobreEditar.vue?vue&type=style&index=0&id=6b4179aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4179aa",
  null
  
)

export default component.exports